/* UI-DESIGN: an explicit code form makes the dossier reachable without a saved session. */
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { useLazyGetPlayerQuery } from "../../reducers/apiSlice";
import GlassPanel from "../../components/lightbox/GlassPanel";
import LightboxButton from "../../components/lightbox/LightboxButton";
import Input from "../../components/input";
import convertErrorMessage from "../../utils/convertErrorMessage";
import styles from "./Passport.module.scss";

interface PlayerFormState { access_code: string }

const PlayerForm = ({ invalidLink = false }: { invalidLink?: boolean }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [trigger, { isFetching }] = useLazyGetPlayerQuery();
  const { register, handleSubmit, formState: { errors }, setError } = useForm<PlayerFormState>({
    defaultValues: { access_code: searchParams.get("access_code") ?? "" },
  });
  const onSubmit = async ({ access_code }: PlayerFormState) => {
    const code = access_code.trim();
    const result = await trigger(code);
    if (result.error) {
      setError("access_code", { message: convertErrorMessage(result.error) });
    } else {
      /* UI-DESIGN: correcting a code keeps the optional route back to the same game. */
      const gameId = searchParams.get("gameId");
      setSearchParams({ access_code: code, ...(gameId ? { gameId } : {}) });
    }
  };
  return (
    <GlassPanel as="form" className={styles.entryForm} onSubmit={handleSubmit(onSubmit)} noValidate>
      <h1 className={styles.headerTitle}>Open your passport</h1>
      <p className={styles.headerSubtitle}>
        {invalidLink ? "That passport couldn’t be opened. Check your code and try again." : "Use the access code in your character email."}
      </p>
      <Input label="Access code" labelClassName={styles.fieldLabel} inputClassName={styles.field}
        register={register("access_code", { required: "Access code is required", validate: value => !!value.trim() || "Access code is required" })}
        error={errors.access_code?.message} type="text" placeholder="Enter access code" />
      <LightboxButton type="submit" isDisabled={isFetching}>{isFetching ? "Opening…" : "Open passport"}</LightboxButton>
    </GlassPanel>
  );
};
export default PlayerForm;
